export class SqlVmPitrRestoreProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryTimestamp",
            "baseName": "recoveryTimestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "databaseNames",
            "baseName": "databaseNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlVmPitrRestoreProperties.attributeTypeMap;
    }
    constructor() {
    }
}
